import { CaretRight, Sparkle } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useUpsell } from '../../context/UpsellContext';

/**
 * @param {{ objectID: string }} props
 */
export const CartLineUpsellTeaser = ({ objectID }) => {
  const { t } = useTranslation();
  const { lineUpsells, openUpsellModal } = useUpsell();
  const id = String(objectID);
  const row = lineUpsells[id];

  if (row?.status === 'loading') {
    return (
      <div className="cart-line-upsell-teaser cart-line-upsell-teaser--loading">
        {t('upsell.teaser_loading')}
      </div>
    );
  }

  if (row?.status !== 'ready' || !row.payload) return null;

  const pct = Math.max(1, Math.round((row.payload.priceDeltaPct || 0) * 100));
  const shortName =
    row.payload.alternative?.name?.length > 42
      ? `${row.payload.alternative.name.slice(0, 40)}…`
      : row.payload.alternative?.name;

  return (
    <button
      type="button"
      className="cart-line-upsell-teaser"
      onClick={() => openUpsellModal(id)}
    >
      <Sparkle size={18} color="#4B164C" weight="fill" style={{ flexShrink: 0 }} />
      <span className="cart-line-upsell-teaser__body">
        <span className="cart-line-upsell-teaser__label">{t('upsell.teaser_label')}</span>
        <span className="cart-line-upsell-teaser__muted"> · </span>
        <span className="cart-line-upsell-teaser__name">{shortName}</span>
        <span className="cart-line-upsell-teaser__muted"> · </span>
        <span className="cart-line-upsell-teaser__pct">{t('upsell.price_plus_pct', { pct })}</span>
      </span>
      <span className="cart-line-upsell-teaser__cta">
        {t('upsell.teaser_details')}
        <CaretRight size={14} />
      </span>
    </button>
  );
};
